//-----------------------------------
// header.js
//-----------------------------------
import $ from 'jquery';
import { TimelineMax, TweenMax, Power2 } from 'gsap';

/*global
TimelineMax
Power2
TweenMax
*/


export let header = {
    init() {
        header.mobileActions();
        header.desktopNav();
        header.cartActions();
    },
    mobileActions(){

        $('.HeaderIconsRight-item--menu').click(function(){
            $('.MobileNavWrap').toggleClass('is-open');
        })

        $('.MobileNav-close').click(function(){
            $('.MobileNavWrap').removeClass('is-open');
        });

        $('.MobileNav-trigger').click(function(){
            if( $(this).hasClass('show') ){
                $(this).siblings('ul').removeClass('show');
                $(this).removeClass('show');
            }else{
                $(this).addClass('show');
                $(this).siblings('ul').addClass('show');
            }
           
        })
    },
    desktopNav(){
        const $desktopNavList = $('.DesktopNav-list');
        $desktopNavList.on('mouseenter', '.DesktopNav-item', function(){
            // check if there are dropdowns associated with this menu 
            if ($(this).hasClass('js-DesktopNav-item')) {
                let the_subnav = $(this).find('.DesktopSubNavWrap');
                if (the_subnav.hasClass('hidden')) {
                    console.log('hidden, unhide');
                    // Remove subnav hidden class
                    the_subnav.removeClass('hidden');
                    // Add a hover state to the main link 

                    // Animate in the subnav
                    TweenMax.to(the_subnav, 0.1, { autoAlpha: 1, display: 'block', ease: Power2.ease });

                    // Hide the siblings if they're open
                    let sibling_navs = $(this)
                                        .siblings('.js-DesktopNav-item')
                                        .find('.DesktopSubNavWrap');
                    // Animate out the sibling navs + add hidden class
                    TweenMax.to(sibling_navs, 0.1, { autoAlpha: 0, display: 'none', ease: Power2.ease });
                    sibling_navs.addClass('hidden');                     
                }
            }else{
                // Hide the siblings if they're open
                let sibling_navs = $(this)
                .siblings('.js-DesktopNav-item')
                .find('.DesktopSubNavWrap');
                // Animate out the sibling navs + add hidden class
                TweenMax.to(sibling_navs, 0.1, { autoAlpha: 0, display: 'none', ease: Power2.ease });
                sibling_navs.addClass('hidden');   
            }
        })

        $desktopNavList.on('mouseleave', '.DesktopSubNavWrap', function() {
            if (!$(this).hasClass('hidden')) {
              console.log('not hidden');
              TweenMax.to($(this), 0.1, { autoAlpha: 0, display: 'none', ease: Power2.ease });
              $(this).addClass('hidden');
            //   $(this)
            //     .closest('.js-NavDesktop-mainMenu-listItem')
            //     .find('.NavDesktop-mainMenu-link')
            //     .removeClass('hover');
            }
          });
    },
    cartActions(){
        const cart = document.getElementById('shopify-section-cart');

        $('.CartTrigger').click(function(){
            cart.classList.toggle('is-open');
            document.body.classList.toggle("noscroll-mobile")
        });

        //cart trigger for keyboard accessibility
        $('.CartTrigger').on('keypress', function(e){
            if(e.which == 13){ // enter key 
                cart.classList.toggle('is-open');
                document.body.classList.toggle("noscroll-mobile")
            }   
        })
    }
}